import { type WidgetSettingsDefinition } from "@repo/api";
import { translateAddPrefix } from "@repo/ui";

import { COMMON_SETTINGS } from "./commonWidgetSettings";

export const QUOTATIONS_SETTINGS: WidgetSettingsDefinition[] = [
  COMMON_SETTINGS.COWORKER,
  COMMON_SETTINGS.STORE,
  {
    id: "quotationValue",
    title: "label.value",
    type: "value_range",
  },
  {
    id: "expiringIn",
    title: "label.quotation_expiry_filter",
    type: "quotation_range",
    defaultValue: ["-30", "3"],
  },
  {
    id: "status",
    title: "label.status",
    type: "selection",
    translator: (key: string) => translateAddPrefix(key, "label"),
    stringValues: ["CREATED", "CANCELED", "CONVERTED"],
    additionalControl: {
      selectionMode: "MULTI",
      showSearch: false,
    },
  },
  {
    id: "customerType",
    title: "label.customer_type",
    type: "selection",
    translator: (key: string) => translateAddPrefix(key, "label", true),
    stringValues: ["Individual", "Business"],
    additionalControl: {
      selectionMode: "MULTI",
      showSearch: false,
    },
  },
  {
    id: "DEPARTMENT",
    title: "label.department",
    type: "department_select",
  },
];
